import {Component, ElementRef, ViewChild, OnInit, OnDestroy} from '@angular/core';
import {Store} from '@ngrx/store';
import {AppState, selectRouterState} from '@store/reducers';
import {ACTIVE_SEARCH_REMOVE, RemoveActiveSearch, SEARCH_RESULT_UPDATE} from '@store/actions';
import {FontAwesomeService} from '@services/font-awesome.service';
import {takeUntil} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';
import {ShipmentTypes} from '@store/reducers/shipments.reducer';
import {SetActiveSearch} from '@store/actions/shipments.action';
import {Subject} from 'rxjs/Subject';
import {Router} from '@angular/router';
import {ShipmentService} from '@services/shipment.service';
import {SnackBarComponent} from '@components/snackbar/snackbar.component';
import {MatSnackBar} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';
import {element} from 'protractor';

@Component({
  selector: 'app-shipments',
  template: `
    <div class="outer-container">
      <h1>{{heading}}</h1>
      <div class="search-container">
        <fa-icon [icon]="faService.faSearch" class="search-icon"></fa-icon>
        <input
          #search
          (keydown.enter)="searchShipments()"
          type="text"
          placeholder="{{'account.section.shipment.searchContainer.placeholder' | translate}}.">
            <!--<button  *ngIf="!isShipmentInfoPage"
              mat-button
              mat-stroked-button
              (click)="searchShipments()"
              color="primary"
              class="go-back"
              type="button">
              <fa-icon [icon]="faService.faSearch" class="plus-circle-icon"></fa-icon>
            </button>-->
            <button *ngIf="isShipmentInfoPage"
                  mat-button
                  mat-stroked-button
                  [routerLink]="['/shipments/' + currentShipmentType.toLowerCase()]"
                  color="primary"
                  class="go-back"
                  type="button">
              <fa-icon [icon]="faService.faBars" class="plus-circle-icon"></fa-icon>
              {{'account.section.shipment.searchContainer.buttonBack' | translate}}
          </button>
          <button *ngIf="showUpdateStatusButton"
                  mat-button
                  mat-raised-button
                  (click)="updateStatus($event)"
                  color="primary"
                  class="update-status"
                  type="button">
              <fa-icon [icon]="faService.faCheckCircle" class="plus-circle-icon"></fa-icon>
              {{'account.section.shipment.searchContainer.buttonUpdateStatus' | translate}}
          </button>
          <button *ngIf="currentShipmentType === 'IMPORT'"
                  mat-button
                  mat-stroked-button
                  [routerLink]="['/shipments/saved']"
                  color="primary"
                  class="go-back"
                  type="button">
              <fa-icon [icon]="faService.faBars" class="plus-circle-icon"></fa-icon>
              {{'account.section.shipment.searchContainer.buttonBack' | translate}}
          </button>
          <button *ngIf="currentShipmentType === 'SAVED'"
              type="button"
              mat-button
              mat-stroked-button
              [routerLink]="['/shipments/import']"
              color="primary">
              <fa-icon [icon]="faService.faCloudUpload"></fa-icon>
              {{'account.section.import.buttonImport' | translate}}
          </button>
        <button mat-button
                mat-raised-button
                [routerLink]="['/create-consignment']"
                color="primary"
                type="button">
          <fa-icon [icon]="faService.faPlusCircle" class="plus-circle-icon"></fa-icon>
          {{'account.section.shipment.searchContainer.buttonNew' | translate}}
        </button>
      </div>
      <router-outlet></router-outlet>
    </div>
  `,
  styleUrls: ['./shipments.component.scss']
})

export class ShipmentsComponent implements OnInit, OnDestroy {
  public shipmentId: number;
  public isShipmentInfoPage: boolean;
  public showUpdateStatusButton = false;
  public currentShipmentType = '';

  public heading = '';

  private currentPage = 1;
  private currentPageSize = 25;
  private unsubscribe: Subject<void> = new Subject();
  private searchQuery = '';

  @ViewChild('search') search: ElementRef;

  constructor(
    private store: Store<AppState>,
    public faService: FontAwesomeService,
    private router: Router,
    private shipmentService: ShipmentService,
    private matSnackBar: MatSnackBar,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.searchQuery = '';
    this.store.select(selectRouterState)
      .subscribe(data => {
        this.shipmentId = parseInt(data.state.url.split('/').slice(-1).pop(), 10);
        const url = data.state.url.split('/').pop();
        if (url.match('saved')) {
          this.currentShipmentType = 'SAVED';
        } else if (url.match('booked')) {
          this.currentShipmentType = 'BOOKED';
        } else if (url.match('ongoing')) {
          this.currentShipmentType = 'ONGOING';
        } else if (url.match('delivered')) {
          this.currentShipmentType = 'DELIVERED';
        } else if (url.match('import')) {
          this.currentShipmentType = 'IMPORT';
        }
        this.isShipmentInfoPage = !!(data.state.params && Object.keys(data.state.params).length);
        this.showUpdateStatusButton = this.isShipmentInfoPage &&
          (this.currentShipmentType === 'BOOKED' || this.currentShipmentType === 'ONGOING');

        this.heading = this.translate.instant('account.section.shipment.' + this.currentShipmentType.toLowerCase() + '.heading');
      });

    /*
    Observable.fromEvent(this.search.nativeElement, 'keyup')
      .pipe(takeUntil(this.unsubscribe))
      .distinctUntilChanged()
      .debounceTime(500)
      .subscribe((event: any) => {
        this.currentPage = 1;
        if (event && event.target && event.target.value) {
          this.store.dispatch(new SetActiveSearch(
            {
              type: ShipmentTypes[this.currentShipmentType],
              activeSearch: event.target.value,
              current_page_size: this.currentPageSize,
              current_page: 1
            }));
          this.router.navigate(['/shipments/' + this.currentShipmentType.toLowerCase()]);
        } else {
          this.store.dispatch(new RemoveActiveSearch({type: ShipmentTypes[this.currentShipmentType]}))
        }
      });
     */
  }

  searchShipments() {
    this.searchQuery = this.search.nativeElement.value;
    if (this.searchQuery !== '') {
      this.store.dispatch(new SetActiveSearch(
        {
          type: ShipmentTypes[this.currentShipmentType],
          activeSearch: this.searchQuery,
          current_page_size: this.currentPageSize,
          current_page: 1
        }));
    } else {
      this.store.dispatch(new RemoveActiveSearch({type: ShipmentTypes[this.currentShipmentType]}));
    }
  }

  updateStatus(event) {
    this.showUpdateStatusButton = false;
    this.shipmentService.updateStatus(this.shipmentId, 'DELIVERED')
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((response) => {
          this.snackBar('Shipment moved to delivered shipments.', false);
        },
        (error) =>  {
          this.showUpdateStatusButton = true;
          this.snackBar(error.status + ' - ' + error.statusText, true);
        },
        () => {
          this.router.navigate(['shipments', this.currentShipmentType.toLowerCase()]);
        });
  }

  private snackBar(text: string, isError: boolean = true): void {
    this.matSnackBar.openFromComponent(SnackBarComponent, {
      data: {
        error: isError,
        message: text
      },
      panelClass: 'snackbar-container',
      duration: 5000,
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shipments/shipments.component.ts